<div>
  <div class="hero"></div>
  <div class="overlay"></div>

  <div class="success-container" *ngIf="!membershipProduct" class="v-center">
    <app-spinner></app-spinner>
  </div>

  <div class="success-container" *ngIf="membershipProduct">

    <div class="confirmation-title">
      <span>THANKS FOR BECOMING A TYT MEMBER </span>
      <span class="plus-tag">
        <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
        <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
      </span>
    </div>

    <div class="product-purchased">
      <div>
        {{ capitalizeFirstLetter(membershipProduct.period) }} Premium Subscription
      </div>

      <div class="price-period">
        ${{ membershipProduct.dollar_price }}/{{ capitalizeFirstLetter(membershipProduct.period) }}
      </div>
    </div>

    <div class="content-view" *ngIf="production">
      <h1>Start {{this.episode ? 'Watching': 'Listening'}}</h1>
      <!-- <ng-container *ngIf="episode"> -->
        <!-- <tyt-production-view class="mini" confirmationPage="true" [production]="production" mode="episodes">
        </tyt-production-view> -->
        <div class="production-content">
          <div class="production-image" [responsiveBackgroundImage]="production.thumbnail_landscape1"></div>

          <div class="right-content">
            <ng-container *ngIf="episode">
                <p>{{episode.description}}</p>
                <div class="extras">
                  <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
                  <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
                  <span class="duration">{{ episode.duration | duration}}</span>
                  <span class="comments">
                    <tyt-comments-count identifier="vod_{{episode.id}}"></tyt-comments-count>
                  </span>
                </div>
                <a routerLink="/watch/{{production.show.slug || production.show.id}}/{{production.id}}/episodes/{{episode.id}}" style="float: left"><tyt-form-submit-button>Watch</tyt-form-submit-button></a>
            </ng-container>

            <ng-container *ngIf="podcast">
                <p>{{podcast.description}}</p>
                <div class="extras">
                  <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
                  <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
                  <span class="duration">{{ podcast.duration | duration}}</span>
                  <span class="comments"><tyt-comments-count identifier="vod_{{podcast.id}}"></tyt-comments-count></span>
                </div>
                <a href="/listen/{{production.show.id}}/{{production.id}}/podcasts/{{podcast.id}}" style="float: left"><tyt-form-submit-button>Listen</tyt-form-submit-button></a>
            </ng-container>
          </div>

        </div>
      <!-- </ng-container> -->

      <!-- <ng-contain *ngIf="this.podcast">
          <tyt-production-view class="mini" confirmationPage="true" [production]="production" mode="podcasts">
          </tyt-production-view>
      </ng-contain> -->



    </div>

    <div class="content">
        <div class="side-bar">
            <h1>Start Watching</h1>
            <tyt-shows-sidebar [title]="''"></tyt-shows-sidebar>
        </div>
        <div class="download-app">
            <h1>On the go</h1>
            <tyt-mobile-ad-block [title]="'Get the most out of your TYT Plus memberships'"></tyt-mobile-ad-block>
        </div>
    </div>


  </div>
</div>
